import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { useMemo } from 'react';

export function useFormatSalesCounterpartTooltip(counterpart?: ISalesCounterpart) {
  return useMemo(
    () => (
      <>
        {[counterpart?.label, counterpart?.id, counterpart?.eliotCode]
          .filter(c => !!c)
          .map((v, i) => (
            <div key={i}>{v}</div>
          ))}
      </>
    ),
    [counterpart],
  );
}
